import React from "react";
import _ from "lodash";
import Select from "react-select";

import { NetworkAPI } from "apis";
import ModalWrapper from "../../../common/ModalWrapper";
import TargetingWithInExControl from "./TargetingWithInExControl";
import CustomRulesSelector from "./CustomRulesSelector";
import CustomTargetingKeysSelector from "components/ops-mgmt/account/cst-config/CustomTargetingKeysSelector";
import CustomTargetingValuesSelector from "components/ops-mgmt/account/cst-config/CustomTargetingValuesSelector";

import { inputClass } from "helpers/StyleClass";

const targetingBlockClass = "border p-2 my-2 bg-white";
const targetingTitleClass = "block text-gray-800 font-bold mb-1"; //"font-semibold";

// Important! not snake case!!!!!!! snake case is in apconfig
const TARGETING_TYPE = {
  OS: "os",
  DC: "deviceCategory",
  COUNTRY: "country",
  BROWSER: "browser",
  CUSTOMS: "customs",
  INVENTORY_TYPES: "inventoryTypes",
  INVENTORY_URL: "inventoryUrl",
  INVENTORY_SIZE: "inventorySize",
  VIDEO_POSITIONS: "videoPositions",
  INVENTORY_FORMAT: "inventoryFormat",
  MOBILE_APPLICATION: "mobileApplication",
};

const ACTION = {
  CHANGE_COUNTRY: "changeCountry",
  UPDATE_LABEL: "updateLabel",
  ADD_I2WOPT: "addI2wOpt",
};

class BatchUpdateRulesModal extends React.Component {
  constructor(props) {
    super(props);

    const selectedRuleIds = _.map(props.selectedRules, "id") || [];

    this.state = {
      selectedRuleIds,
      newTargetingSection: {},
      labelInput: "",
      selectedAction: ACTION.CHANGE_COUNTRY,
      actionOption: [
        {
          label: "Change Country",
          value: ACTION.CHANGE_COUNTRY,
        },
        {
          label: "Update Label",
          value: ACTION.UPDATE_LABEL,
        },
        {
          label: "Add I2W Billing Key",
          value: ACTION.ADD_I2WOPT,
        },
      ],
      optImport: {
        keyId: "",
        valueIds: [],
        operator: "IS",
      },
    };

    this.handleRulesChanged = this.handleRulesChanged.bind(this);
    this.handleBatchUpdate = this.handleBatchUpdate.bind(this);
  }

  async componentDidMount() {
    const { cstConfig } = await NetworkAPI.getCstConfig({
      networkId: this.props.networkId,
    });

    if (
      cstConfig &&
      cstConfig.general &&
      cstConfig.general.key &&
      cstConfig.general.managedValues
    ) {
      this.setState({
        optImport: {
          keyId: cstConfig.general.key.id.toString(),
          valueIds: cstConfig.general.managedValues.map((v) => v.id.toString()),
          operator: "IS",
        },
      });
    }
  }

  handleRulesChanged(rules) {
    if (_.isEmpty(this.state.newTargetingSection)) {
      const newTargetingSection = _.get(
        _.find(this.props.customRules, {
          id: _.first(rules),
        }),
        "targetingSection"
      );
      this.setState({
        newTargetingSection: _.cloneDeep(newTargetingSection),
      });
    }
    this.setState({ selectedRuleIds: rules });
  }

  handleTargetingChanged(targeting, key) {
    let { newTargetingSection } = this.state;

    if (!targeting) {
      newTargetingSection = _.omit(newTargetingSection, key);
    } else newTargetingSection[key] = targeting;

    this.setState({
      newTargetingSection,
    });

    // let newRule = this.props.uprSetting;
    // newRule.targetingSection = targetingSection;
    // this.props.handleCurrentRuleChanged(newRule);
  }

  handleBatchUpdate() {
    const {
      selectedRuleIds,
      newTargetingSection,
      selectedAction,
      labelInput,
      optImport,
    } = this.state;

    if (selectedAction === ACTION.CHANGE_COUNTRY) {
      this.props.handleBatchUpdateRules(selectedRuleIds, {
        content: newTargetingSection,
        type: TARGETING_TYPE.COUNTRY,
      });
    } else if (selectedAction === ACTION.UPDATE_LABEL) {
      this.props.handleBatchUpdateRules(selectedRuleIds, {
        content: { label: labelInput },
        type: "label",
      });
    } else if (selectedAction === ACTION.ADD_I2WOPT) {
      this.props.handleBatchUpdateRules(selectedRuleIds, {
        content: { customs: optImport },
        type: "customs",
      });
    }
  }

  render() {
    const {
      isModalOpen,
      formErrMsg,
      isEditing,

      isSaving,

      handleCloseModal,
      customRules,
      networkId,
    } = this.props;

    const {
      selectedRuleIds,
      newTargetingSection,
      selectedAction,
      actionOption,
      labelInput,
      optImport,
    } = this.state;

    const parseSelect = _.find(
      actionOption,
      (opt) => opt.value === selectedAction
    );

    const isInvalid =
      (selectedAction === ACTION.UPDATE_LABEL && labelInput === "") ||
      (selectedAction === ACTION.ADD_I2WOPT &&
        (optImport.keyId === undefined || optImport.keyId === ""));

    return (
      <ModalWrapper
        isOpen={isModalOpen}
        showCloseFooter={false}
        handleClose={handleCloseModal}
        customOverlayStyle={{ zIndex: 100 }}
        width="75%"
        height="80%"
        title="Batch Update Rules"
      >
        <div
          className="flex flex-col justify-between"
          style={{ height: "calc(100% - 3rem)" }}
        >
          <div
            className="border overflow-y-auto"
            style={{ height: "calc(100% - 3rem)" }}
          >
            <div className="rounded mb-4 bg-white px-6 pb-6 pt-4">
              <div className="mb-4">
                <label
                  className="block text-lg font-bold text-gray-800"
                  htmlFor="rules"
                >
                  Select rules to update ({selectedRuleIds.length})
                </label>
                <CustomRulesSelector
                  rules={customRules}
                  selectedItems={selectedRuleIds}
                  handleChanged={this.handleRulesChanged}
                ></CustomRulesSelector>
              </div>
              <div className="border-b mb-4 pb-4">
                <label className="block text-lg font-bold text-gray-800">
                  Select action
                </label>
                <Select
                  value={parseSelect}
                  onChange={(option) =>
                    this.setState({ selectedAction: option.value })
                  }
                  options={actionOption}
                ></Select>
              </div>
              {!_.isEmpty(selectedRuleIds) && (
                <div className="rounded mb-4 bg-gray-300 px-4 py-2">
                  {selectedAction === ACTION.CHANGE_COUNTRY && (
                    <>
                      <div className="border-b mt-2 text-lg font-bold">
                        Targeting
                      </div>

                      <div className={targetingBlockClass}>
                        <div className={targetingTitleClass}>Country</div>
                        <TargetingWithInExControl
                          targetingType={TARGETING_TYPE.COUNTRY}
                          targeting={
                            newTargetingSection[TARGETING_TYPE.COUNTRY]
                          }
                          handleTargetingChanged={(t) =>
                            this.handleTargetingChanged(
                              t,
                              TARGETING_TYPE.COUNTRY
                            )
                          }
                        ></TargetingWithInExControl>
                      </div>
                    </>
                  )}
                  {selectedAction === ACTION.UPDATE_LABEL && (
                    <>
                      <label
                        className="block font-bold text-gray-800"
                        htmlFor="label"
                      >
                        Label
                      </label>
                      <input
                        className={inputClass}
                        id="label"
                        type="text"
                        value={labelInput}
                        onChange={(e) =>
                          this.setState({ labelInput: e.target.value })
                        }
                      />
                    </>
                  )}
                  {selectedAction === ACTION.ADD_I2WOPT && (
                    <>
                      <div className="border-b mt-2 text-lg font-bold">
                        Customs
                      </div>
                      <div className={targetingBlockClass}>
                        <div className="border rounded w-full bg-white p-1 text-gray-700">
                          <div className="float-right">
                            Operator:{" "}
                            <span className="rounded bg-green-500 px-2 text-sm font-semibold  text-white">
                              {optImport.operator}
                            </span>
                          </div>

                          <div>
                            Key ID:{" "}
                            <span className="font-semibold">
                              {optImport.keyId || "--"}
                            </span>
                            <CustomTargetingKeysSelector
                              keyId={optImport.keyId}
                              isReadonly={true}
                              networkId={networkId}
                            ></CustomTargetingKeysSelector>
                          </div>
                          {optImport.keyId === undefined && (
                            <div className="text-red-600">
                              The intowow_optimized key could not be found in
                              this network.
                            </div>
                          )}
                          {optImport.keyId && (
                            <div>
                              Value IDs (
                              {optImport.valueIds
                                ? optImport.valueIds.length
                                : 0}
                              ):{" "}
                              <CustomTargetingValuesSelector
                                isReadonly={true}
                                networkId={networkId}
                                keyId={optImport.keyId}
                                managedValueIds={optImport.valueIds}
                                isMulti={true}
                              ></CustomTargetingValuesSelector>
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="flex w-full items-center justify-end pt-4">
            <div className="text-red-600">{formErrMsg}</div>
            <button
              type="button"
              disabled={isSaving}
              className={`px-4 py-2 text-blue-700 ${
                isSaving ? "cursor-not-allowed" : ""
              }`}
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button
              type="button"
              className={`px-4 py-2 ${
                isEditing || isSaving || isInvalid
                  ? "cursor-not-allowed bg-gray-400 text-gray-800"
                  : "bg-blue-500 text-white hover:bg-blue-700"
              }  rounded shadow font-semibold`}
              onClick={this.handleBatchUpdate}
              disabled={isSaving || isEditing || isInvalid}
            >
              {isSaving ? "Saving..." : "Update rules"}
            </button>
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

export default BatchUpdateRulesModal;
